<template>
    <div class="main-home" style = "margin-left:20px">
      <HeaderPage />
      <div style="marigin-left:50px;">
        <div style="display: flex;margin-bottom:30px;">
          <el-button 
          @click="showCreateDialog"
          type="primary" 
          style="margin-left:20px;margin-right:100px;margin-top:20px;background:#0049c8;color:#ffffff;border:none">新建项目</el-button>
          <CreateProject :is-show="createProjectShow" @closeCreateDialog="closeCreateDialog()"/>
          <el-input style="width:220px;margin-top:20px;"></el-input><el-button type="primary" icon="el-icon-search" style="background:#0049c8;margin-top:20px;margin-left:20px;color:#ffffff;border:none">搜索</el-button>
          <el-button type="primary"  
          style="margin-right:30px;margin-left: auto;margin-top:20px;background:#0049c8;color:#ffffff;border:none" @click="showDataDialog()">查看所有数据文件</el-button>
          <AllFileData :is-show="dataShow" @closeDialog="closeDataDialog()"/>
        </div>
        <div style = "border-radius:12px;border:1px solid #dcdfe6;padding:20px;margin-top:10px">
        <ProjectData />
      </div>
      </div>
    </div>
  </template>

<script>
import HeaderPage from './HeaderPage.vue';
import ProjectData from './ProjectData.vue';
import AllFileData from './DialogView/AllFileData.vue';
import CreateProject from './DialogView/CreateProject.vue';
export default {
  name: 'ProjectManagement',
  components:{
    HeaderPage,
    ProjectData,
    AllFileData,
    CreateProject
  },
  props: {
    msg: String
  },
  data(){
    return{
      dataShow:false,
      createProjectShow:false,
      projectName:'',
    };
  },
  methods:{
    showDataDialog(){
      this.dataShow=true
    },
    closeDataDialog(){
      this.dataShow=false
    },
    showCreateDialog(){
      this.createProjectShow=true
    },
    closeCreateDialog(){
      this.createProjectShow=false
    },
    add_onclick(){
      return false;
    }
  },
  created(){
    // this.$router.push({
    //               path: '/login'
    //           }) ;
  }
}
  
  </script>
  <style>
  .bm-overlay {
    background: #fff;
  }
  .bm-menu {
        height: 50%; /* 100% Full-height */
        width: 0; /* 0 width - change this with JavaScript */
        position: fixed; /* Stay in place */
        z-index: 1000; /* Stay on top */
        top: 0;
        left: 0;
        box-shadow: -1px 0px 10px 0px rgba(0,0,0,0.5);
        background-color: #ffffff; /* Black*/
        overflow-x: hidden; /* Disable horizontal scroll */
        padding-top: 60px; 
        transition: 0.5s; 
      }
      input#file-upload-button{
    display: none;
  }
  </style>
  <style lang="less" scoped>
  
  /deep/ .bm-burger-button{
        height: 15px;
        width:20px;
  }
  /deep/ .line-style{
        position: absolute;
        height: 20%;
        width:15px;
        left: 0;
        right: 0;
      }
  .hamburger{
      .cross-style {
        position: absolute;
        top: 12px;
        right: 2px;
        cursor: pointer;
      }
      .bm-cross {
        background: #bdc3c7;
      }
      .bm-cross-button {
        height: 24px;
        width: 24px;
      }
      .bm-menu {
        height: 100%; /* 100% Full-height */
        width: 0; /* 0 width - change this with JavaScript */
        position: fixed; /* Stay in place */
        z-index: 1000; /* Stay on top */
        top: 0;
        left: 0;
        background-color: rgb(63, 63, 65); /* Black*/
        overflow-x: hidden; /* Disable horizontal scroll */
        padding-top: 60px; /* Place content 60px from the top */
        transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
      }
   
      .bm-overlay {
        background: #fff;
      }
      .bm-item-list {
        color: #b8b7ad;
        margin-left: 10%;
        font-size: 20px;
      }
      .bm-item-list > * {
        display: flex;
        text-decoration: none;
        padding: 0.7em;
      }
      .bm-item-list > * > span {
        margin-left: 10px;
        font-weight: 700;
        color: white;
      }
    }
  .category-box{
      display: flex;
      font-size: 14px;
      .category-label{
          min-width: 50px;
          color: #999;
          padding-top: 3px;
          padding-right: 15px;
      }
      .category-list{
          display: flex;
          flex-flow: row wrap;
          align-items: center;
  
          .category-item {
              margin: 0 10px 5px 0;
              padding: 4px 10px;
              color: #666;
              border-radius: 12px;
              outline: none;
              cursor: pointer;
              &-active{
                  color: #ff7752;
                  font-weight: 500;
                  background-color: #ddebf8;
              }
          }
      }
  }
  .flex-1 {
      flex: 1;
  }
  .category-two-menu-box.el-tooltip__popper.is-light{
      box-shadow: 0 2px 12px 0 #e1e3e6;
      border: 1px solid #f0f0f0;
  }
  .category-two-menu-box.el-tooltip__popper {
      padding: 0;
  }
  .category-two-menu-box .el-cascader-node:hover {
      color: #ff7752;
  }
  .category-two-menu-box .el-cascader-node.is-active {
      color: #ff7752;
  }
  .category-two-menu-box.el-tooltip__popper.is-light .el-cascader-panel.is-bordered {
      border-radius: 0;
      border: 0 none;
  }
  .category-two-menu-box.el-tooltip__popper.is-light .popper__arrow {
      border-bottom-color: #f0f0f0!important;
  }
  </style>
